module.exports = __webpack_public_path__ + "static/media/iphone_11_pro_midnight_green.b9573861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_pro_midnight_green.png
// module id = 2068
// module chunks = 0